import { useState, useEffect } from 'react';
import {color_grey_dark, color_grey_light, color_grey_ultra_light} from "../../constants/colors";
import ModalCookies from '../blocks/ModalCookies';
import { useWindowDimensions } from '../../utils';
/* 
function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height
  };
}

function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowDimensions;
}
 */
const DefaultPage = ({children}) => {
  const { height } = useWindowDimensions();
 
  return (
    <div style={{
      width: "100%",
      maxWidth: "100%",
      minWidth: 0,
      minHeight: height,
      boxSizing: "border-box",
      backgroundColor: color_grey_ultra_light
    }}>
        {children}
      <ModalCookies />
    </div>
  );
}

export default DefaultPage